export default __webpack_public_path__ + "static/media/DreamsHotel_resort&spa.bacbcf9e.png";